export enum ErosAdapterTypeEnum {
    Test = 'test',
    CzechEet = 'czech_eet',
    SlovakEet = 'slovak_eet',
}
